module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"product-details-26":{"article-number":"Varenr."}},"de":{"product-details-26":{"article-number":"Art.-Nr."}},"fr":{"product-details-26":{"article-number":"Art n°"}},"nl":{"product-details-26":{"article-number":"Art.nr."}}}')
  delete Component.options._Ctor
}
